
import Vue from 'vue'

const getDefaultState = () => {
    return {
        toDoManager: {
            id: 0,
        }
    }
};

const state = getDefaultState();

const actions = {

    resetState({ commit }) {
        commit('resetState');
    },

    saveState({ commit }, payload) {
        commit('saveState', payload);
    },

    async List() {

        try {
            const result = await Vue.prototype.$vanKirkApi.get("to-do-manager/list",
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                const list = result.data.result;

                return list;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list to do manager: [${ex}]`
            };
        }
    },

    async GetById(_, id) {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`to-do-manager/${id}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {
                return result.data;
            }
            else {
                return {
                    success: false,
                    result: `Error to get to do manager`
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                result: `Error to get to do manager: [${ex}]`
            };
        }
    },

    async CreateUpdate(_, toDoRequest) {

        try {

            const result = await Vue.prototype.$vanKirkApi.post(`to-do-manager/create-update`, toDoRequest,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 204) {

                let msg = "Register updated with success!";

                if (toDoRequest.id === 0) {
                    msg = "Record created successfully";
                }

                return {
                    success: true,
                    message: msg
                };
            }
            else {
                return {
                    success: false,
                    message: "Error to create/update register!"
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `Error to create/update register: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    message: `Error to create/update register: [${error}]`
                };
            }
        }
    },

    async Delete(_, id) {

        try {
            const result = await Vue.prototype.$vanKirkApi.delete(`to-do-manager/${id}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {

                return {
                    success: true,
                    message: "Register deleted with success!"
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `Error to delete the register: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    message: `Error to delete the register: [${error}]`
                };
            }
        }
    },
    
    async UpdateStatus(_, { id, statusId }) {

        try {
            const result = await Vue.prototype.$vanKirkApi.put(`to-do-manager/update-status/${id}/${statusId}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 204) {
                return {
                    success: true,
                    message: "Status updated with success!"
                };
            }
            else {
                return {
                    success: false,
                    message: "Error updating the status!"
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error updating the status: [${ex}]`
            };
        }
    },

    async CreateAutoToDo() {

        try {
            await Vue.prototype.$vanKirkApi.post(`to-do-manager/create-auto-todo`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `Error to run create auto todo register: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    message: `Error to run create auto todo register: [${error}]`
                };
            }
        }
    },
    
    async ListHistory(_, filterRequest) {

        try {
            const result = await Vue.prototype.$vanKirkApi.post("to-do-manager/list-history", filterRequest, 
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                const list = result.data.result;

                return list;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list history: [${ex}]`
            };
        }
    },
}

const mutations = {

    saveState: (state, newValue) => {
        Object.assign(state.toDo, newValue);
    },

    resetState: (state) => {
        Object.assign(state, getDefaultState());
    }
}

const getters = {

    searchState: (state) => {
        return state.toDo;
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
